import { render, staticRenderFns } from "./PassiveBrand.vue?vue&type=template&id=89e29d44"
import script from "./PassiveBrand.vue?vue&type=script&lang=js"
export * from "./PassiveBrand.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports